export const STORE_MONGO_CONSOLE = 'mongoConsoleUI';
export type STORE_MONGO_CONSOLE = typeof STORE_MONGO_CONSOLE;
